import React, { useState } from 'react';
import axios from 'axios';
import './AddRoom.css';  // Import the new CSS styles

const AddRoom = () => {
  const [roomType, setRoomType] = useState('');
  const [pricePerNight, setPricePerNight] = useState('');
  const [maxPersons, setMaxPersons] = useState('');
  const [description, setDescription] = useState('');
  const [images, setImages] = useState([]);  // Array for storing multiple images
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Handle multiple image file selection
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setImages(files);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate inputs
    if (!roomType || !pricePerNight || !maxPersons || !description || images.length === 0) {
      setErrorMessage('Please fill in all fields and upload at least one image.');
      return;
    }

    const roomData = new FormData();
    roomData.append('room_type', roomType);
    roomData.append('price_per_night', pricePerNight);
    roomData.append('max_persons', maxPersons);
    roomData.append('description', description);

    // Append each selected image to the FormData
    images.forEach((image, index) => {
      roomData.append('images', image);  // 'images' will hold all files on the server side
    });

    try {
      // Send POST request to Flask backend to add a new room with images
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/rooms`, roomData, {
        headers: {
          'Content-Type': 'multipart/form-data',  // Required for file upload
        },
      });

      if (response.status === 201) {
        setSuccessMessage('Room added successfully!');
        setRoomType('');
        setPricePerNight('');
        setMaxPersons('');
        setDescription('');
        setImages([]);  // Clear the images input
      }
    } catch (error) {
      setErrorMessage('Failed to add room. Please try again later.');
    }
  };

  return (
    <div className="add-room-container">
      <h1 className="add-room-title">Add New Room</h1>

      {/* Error or success message */}
      {errorMessage && <div className="error-message"><p>{errorMessage}</p></div>}
      {successMessage && <div className="success-message"><p>{successMessage}</p></div>}

      <div className="form-container">
        <form onSubmit={handleSubmit} className="add-room-form">
          <label className="form-label">Room Type:</label>
          <select 
            className="form-select" 
            value={roomType} 
            onChange={(e) => setRoomType(e.target.value)} 
            required
          >
            <option value="">Select Room Type</option>
            <option value="family">Family Room</option>
            <option value="double">Double Room</option>
            <option value="twin">Twin Room</option>
          </select>

          <label className="form-label">Price per Night (£):</label>
          <input
            type="number"
            className="form-input"
            value={pricePerNight}
            onChange={(e) => setPricePerNight(e.target.value)}
            required
          />

          <label className="form-label">Max Persons:</label>
          <input
            type="number"
            className="form-input"
            value={maxPersons}
            onChange={(e) => setMaxPersons(e.target.value)}
            required
          />

          <label className="form-label">Description:</label>
          <textarea
            className="form-input"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />

          {/* Image Upload Section */}
          <div className="image-upload-container">
            <label className="image-upload-button" htmlFor="image-upload">Choose Images</label>
            <input
              type="file"
              id="image-upload"
              className="custom-file-input"
              accept="image/*"
              multiple // Allows multiple files
              onChange={handleImageChange}
              required
            />
          </div>

          {images.length > 0 && (
            <div className="image-preview">
              <p>Selected images:</p>
              <ul>
                {images.map((image, index) => (
                  <li key={index}>
                    <img src={URL.createObjectURL(image)} alt={image.name} />
                  </li>
                ))}
              </ul>
            </div>
          )}

          <button type="submit" className="submit-button">Add Room</button>
        </form>
      </div>
    </div>
  );
};

export default AddRoom;
